<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-position="right" label-width="150px">
            <div class="header">
                <div>基本信息</div>
            </div>
            <el-row>
                <el-col :span="16">
                    <el-col :span="12">
                        <el-form-item label="身份证号" prop="sfzhm">
                            <el-input v-model="form.sfzhm" placeholder="请输入" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="xm">
                            <el-input v-model="form.xm" placeholder="请输入" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别" prop="xb">
                            <el-select v-model="form.xb" style="width: 100%">
                                <el-option v-for="item in options.genderList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="民族" prop="mz">
                            <el-select v-model="form.mz" filterable placeholder="请输入（可搜索）" style="width: 100%">
                                <el-option v-for="item in options.nationList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="出生年月" prop="csny">
                            <el-date-picker v-model="form.csny" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width: 100%">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="政治面貌" prop="zzmm">
                            <el-select v-model="form.zzmm" style="width: 100%">
                                <el-option v-for="item in options.politicsFaceList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号码" prop="lxdh">
                            <el-input v-model="form.lxdh" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="籍贯" prop="jg">
                            <el-cascader style="width: 100%;" clearable :options="selectJg" v-model="form.jg"> </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身高（cm）" prop="sg">
                            <el-input v-model="form.sg" placeholder="请输入" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="体重（kg）" prop="tz">
                            <el-input v-model="form.tz" placeholder="请输入" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col :span="8">
                    <div class="baseinfo-image">
                        <div>
                            <span class="red">*&nbsp;</span>个人照片
                        </div>
                        <img class="image" :src="form.imageSrc" />
                        <el-upload action="" :on-change="imageChange" :show-file-list="false" :auto-upload="false">
                            <el-button size="small" type="primary">上传图片</el-button>
                        </el-upload>
                        <div class="red" :class="{ show: showMessage, hide: !showMessage }">
                            请上传个人照片
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div class="header">
                <div>学习经历</div>
            </div>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="学历" prop="dyxl">
                        <el-select v-model="form.dyxl" placeholder="请选择" style="width: 100%" @change="changeDyxl">
                            <el-option v-for="item in options.educationList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="是否国外院校" prop="sfgwyx">
                        <el-select v-model="form.sfgwyx" placeholder="请选择" style="width: 100%;" @change="changeSfgwyx">
                            <el-option v-for="item in options.sfgwyxList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="毕业学校" prop="dyxlbyxx">
                        <el-input
                            :placeholder="showByxxSearchButton? '请点击放大镜选择' : '请输入'"
                            v-model="form.dyxlbyxx"
                            class="input-with-select"
                            :disabled="showByxxSearchButton"
                        >
                            <el-button
                                @click="searchUniversity('dyxlbyxx')"
                                slot="append"
                                icon="el-icon-search"
                                v-if="showByxxSearchButton"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="入学时间" prop="rxsj">
                        <el-date-picker v-model="form.rxsj" type="date" value-format="yyyy-MM-dd" placeholder="前选择" style="width: 100%;">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="毕业时间" prop="bysj">
                        <el-date-picker v-model="form.bysj" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width: 100%">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="所学专业" prop="dyxlsxzy">
                        <el-input
                            :placeholder="showSxzySearchButton? '请点击放大镜选择' : '请输入'"
                            v-model="form.dyxlsxzy"
                            class="input-with-select"
                            @change="changeDyxlsxzy"
                            :disabled="showSxzySearchButton"
                        >
                            <el-button
                                @click="searchMajor"
                                slot="append"
                                icon="el-icon-search"
                                v-if="showSxzySearchButton"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="院校类别" prop="xxlb">
                        <el-select v-model="form.xxlb" placeholder="请选择" style="width: 100%" :disabled="form.sfgwyx === '1'">
                            <el-option v-for="item in options.collegeList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="教育形式" prop="jyxs">
                        <el-select v-model="form.jyxs" placeholder="请选择" style="width: 100%">
                            <el-option v-for="item in options.jyxsList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="研究方向" prop="zyyjfx">
                        <el-input v-model="form.zyyjfx" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                
            </el-row>
            
            <el-row>
                <el-col :span="8">
                    <el-form-item label="英语水平" prop="yysp">
                        <el-select v-model="form.yysp" style="width: 100%">
                            <el-option v-for="item in options.yyspList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="计算机水平" prop="jsjsp">
                        <el-select v-model="form.jsjsp" style="width: 100%">
                            <el-option v-for="item in options.jsjspList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="在校职务" prop="zw">
                        <el-input v-model="form.zw" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="获奖情况及特长" prop="hjqkjtc">
                        <el-input v-model="form.hjqkjtc" type="textarea" placeholder="请输入" show-word-limit maxlength="500" :autosize = "{ minRows: 3}"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="form.dyxl === '11' || form.dyxl === '14'">
                <el-col :span="8">
                    <el-form-item label="本科毕业学校" prop="bkbyxx">
                        <el-input
                            placeholder="请点击放大镜选择"
                            v-model="form.bkbyxx"
                            class="input-with-select"
                            disabled
                        >
                            <el-button
                                @click="searchUniversity('bkbyxx')"
                                slot="append"
                                icon="el-icon-search"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="本科所学专业" prop="bksxzy">
                        <el-input
                            placeholder="请点击放大镜选择"
                            v-model="form.bksxzy"
                            class="input-with-select"
                            disabled
                        >
                            <el-button
                                @click="searchBkMajor"
                                slot="append"
                                icon="el-icon-search"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="header">
                <div>其他</div>
            </div>
            <el-row>
                <el-col :span="16">
                    <el-form-item label="拟应聘岗位" prop="gwlbmc">
                        <el-input
                            placeholder="请点击放大镜选择"
                            v-model="form.gwlbmc"
                            class="input-with-select"
                            disabled
                        >
                            <el-button
                                @click="searchGw"
                                slot="append"
                                icon="el-icon-search"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="是否有服兵役经历" prop="sfyfbyjl">
                        <el-select v-model="form.sfyfbyjl" placeholder="请选择" style="width: 100%;" @change="changeSfyfbyjl">
                            <el-option v-for="item in options.sfyfbyjlList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="服兵役开始时间" prop="fbykssj" :rules="form.sfyfbyjl === '0' ? rules.fbykssj:[{required: true, message: '请选择服兵役开始时间', trigger: ['change']}]">
                        <el-date-picker v-model="form.fbykssj" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width: 100%;">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="服兵役结束时间" prop="fbyjssj" :rules="form.sfyfbyjl === '0' ? rules.fbyjssj:[{required: true, message: '请选择服兵役开始时间', trigger: ['change']}]">
                        <el-date-picker v-model="form.fbyjssj" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width: 100%;">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注" prop="bz">
                        <el-input v-model="form.bz" type="textarea" placeholder="学习经历、社会实践等" show-word-limit maxlength="500" :autosize="{ minRows: 3}"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="header" style="margin-bottom: 10px">
                <div>附件上传<span style="color: red; margin-left: 5px; font-weight: 100; font-size: 13px;">（注意：附件格式统一为PDF、JPG或DOCX，可使用扫描仪扫描、手机拍照（必须平整），建议附件按"学校名称-专业名称-姓名-附件类型"重命名后分类上传）</span></div>
            </div>
            <el-row>
                <el-col :span="7">
                    <el-form-item label="求职简历" required>
                        <el-upload action="" :multiple="false" :on-change="qzjlUploadChange" :auto-upload="false" :limit="1">
                            <el-button type="primary">点击上传</el-button>
                        </el-upload>
                        <div style="color: red;" v-if="showQzjlFileMsg">
                            请上传求职简历
                        </div>
                        <el-row>
                            <el-col :span="24">
                                <div class="file-upload">
                                    <div class="success">
                                        <!-- <div>上传成功文件</div> -->
                                        <div v-for="(item, index) in qzjlFileSuccessList" :key="item.uid">
                                            {{ item.raw.name + "  " }}
                                            <span class="delete" @click="deleteFile(index,'1')">删除</span>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="成绩表">
                        <el-upload action="" :multiple="false" :on-change="cjbUploadChange" :auto-upload="false" :limit="1">
                            <el-button type="primary">点击上传</el-button>
                        </el-upload>
                        <el-row>
                            <el-col :span="24">
                                <div class="file-upload">
                                    <div class="success">
                                        <!-- <div>上传成功文件</div> -->
                                        <div v-for="(item, index) in cjbFileSuccessList" :key="item.uid">
                                            {{ item.raw.name + "  " }}
                                            <span class="delete" @click="deleteFile(index,'2')">删除</span>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="就业推荐表">
                        <el-upload action="" :multiple="false" :on-change="jytjbUploadChange" :auto-upload="false" :limit="1">
                            <el-button type="primary">点击上传</el-button>
                        </el-upload>
                        <el-row>
                            <el-col :span="24">
                                <div class="file-upload">
                                    <div class="success">
                                        <!-- <div>上传成功文件</div> -->
                                        <div v-for="(item, index) in jytjbFileSuccessList" :key="item.uid">
                                            {{ item.raw.name + "  " }}
                                            <span class="delete" @click="deleteFile(index,'3')">删除</span>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-row>
                <el-col :span="4" :offset="2">
                    <el-upload action="" :multiple="false" :on-change="qzjlUploadChange" :auto-upload="false" :limit="1">
                        <el-button type="primary">上传求职简历</el-button>
                    </el-upload>
                    <el-row>
                        <el-col :span="24"
                            ><div class="file-upload" v-if="qzjlFileFailList.length > 0 || qzjlFileSuccessList.length > 0">
                                <div class="success">
                                    <div>上传成功文件</div>
                                    <div v-for="(item, index) in qzjlFileSuccessList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span class="delete" @click="deleteFile(index,'1')">删除</span>
                                    </div>
                                </div>
                                <div class="fail" v-if="qzjlFileFailList.length > 0">
                                    <div>上传失败文件</div>
                                    <div v-for="(item, index) in qzjlFileFailList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span style="color: #2a8ae0; cursor: pointer" @click="reUploadFile(index,'1')">
                                            重新上传
                                        </span>
                                        <span class="delete" @click="removeFile(index,'1')">{{ "删除    " }}</span>
                                    </div>
                                </div>
                            </div></el-col
                        >
                    </el-row>
                    
                </el-col>
                
                <el-col :span="4" :offset="1">
                    <el-upload action="" :multiple="false" :on-change="cjbUploadChange" :auto-upload="false" :limit="1">
                        <el-button type="primary">上传成绩表</el-button>
                    </el-upload>
                    <el-row>
                        <el-col :span="24"
                            ><div class="file-upload" v-if="cjbFileFailList.length > 0 || cjbFileSuccessList.length > 0">
                                <div class="success">
                                    <div>上传成功文件</div>
                                    <div v-for="(item, index) in cjbFileSuccessList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span class="delete" @click="deleteFile(index,'2')">删除</span>
                                    </div>
                                </div>
                                <div class="fail" v-if="cjbFileFailList.length > 0">
                                    <div>上传失败文件</div>
                                    <div v-for="(item, index) in cjbFileFailList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span style="color: #2a8ae0; cursor: pointer" @click="reUploadFile(index,'2')">
                                            重新上传
                                        </span>
                                        <span class="delete" @click="removeFile(index,'2')">{{ "删除    " }}</span>
                                    </div>
                                </div>
                            </div></el-col
                        >
                    </el-row>
                </el-col>
                <el-col :span="4" :offset="1">
                    <el-upload action="" :multiple="false" :on-change="jytjbUploadChange" :auto-upload="false" :limit="1">
                        <el-button type="primary">上传就业推荐表</el-button>
                    </el-upload>
                    <el-row>
                        <el-col :span="24"
                            ><div class="file-upload" v-if="jytjbFileFailList.length > 0 || jytjbFileSuccessList.length > 0">
                                <div class="success">
                                    <div>上传成功文件</div>
                                    <div v-for="(item, index) in jytjbFileSuccessList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span class="delete" @click="deleteFile(index,'3')">删除</span>
                                    </div>
                                </div>
                                <div class="fail" v-if="jytjbFileFailList.length > 0">
                                    <div>上传失败文件</div>
                                    <div v-for="(item, index) in jytjbFileFailList" :key="item.uid">
                                        {{ item.raw.name + "  " }}
                                        <span style="color: #2a8ae0; cursor: pointer" @click="reUploadFile(index,'3')">
                                            重新上传
                                        </span>
                                        <span class="delete" @click="removeFile(index,'3')">{{ "删除    " }}</span>
                                    </div>
                                </div>
                            </div></el-col
                        >
                    </el-row>
                </el-col>
            </el-row> -->
            
            <!-- <div style="margin-bottom: 100px"></div> -->
        </el-form>
        <search-university-dialog @choiceData="choiceUniversity" ref="searchUniversityDialog" />
        <search-major-dialog @choiceData="choiceMajor" ref="searchMajorDialog" />
        <search-gw-dialog @choiceData="choiceGw" ref="searchGwDialog" />
    </div>
</template>

<script>
import share from "@/assets/sharejs/share.js";
import request from "@/api/postList.js";
import { provinceAndCityData } from "element-china-area-data";
import { identityRegPlus } from "@/api/regExp.js";
import searchUniversityDialog from './searchUniversityDialog.vue';
import searchMajorDialog from './searchMajorDialog.vue';
import searchGwDialog from './searchGwDialog.vue';
// import {pcs} from "@/assets/pc_code.json";
// let pcs = require('C:\ssdw\WHSA\src\assets\pc_code.json')

export default {
    mounted() {
        let userInfo = share.get("userInfo");
        this.form.sfzhm = userInfo.yxzjhm;
        this.form.xm = userInfo.xm;
        this.form.lxdh = userInfo.sjhm;
        if (this.data.zplb == '2') {
            //高技能人才招聘学历
            this.options = {
                ...this.options,
                educationList: [
                    {key: '61', value: '技工学校'},
                    {key: '40', value: '中等专科'},
                    {key: '30', value: '大学专科'},
                    {key: '20', value: '大学本科'},
                    {key: '21', value: '大学本科（职业类）'},
                    {key: '14', value: '硕士研究生'},
                    {key: '99', value: '其他'}
                ],
            }
        }else {
            //高校毕业生招聘学历
            this.options = {
                ...this.options,
                educationList: [
                    {key: '20', value: '大学本科'},
                    {key: '14', value: '硕士研究生'},
                    {key: '11', value: '博士研究生'}
                ],
            }
        }
        console.log('>>>>', share.get("xl"))
        // console.log('城市信息》》》',pcs);
    },
    props: {
        data: {
            type: Object,
        },
    },
    components:{
        searchUniversityDialog,
        searchMajorDialog,
        searchGwDialog,
    },
    data() {
        var isMobileNumber = (rule, value, callback) => {
            if (!value) {
                return new Error("请输入手机号码");
            } else {
                const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
                const isPhone = reg.test(value);
                value = Number(value); //转换为数字
                if (typeof value === "number" && !isNaN(value)) {//判断是否为数字
                    value = value.toString(); //转换成字符串
                    if (value.length < 0 || value.length > 12 || !isPhone) { //判断是否为11位手机号
                        callback(new Error("请输入正确的手机号码"));
                    } else {
                        callback();
                    }
                } else {
                    callback(new Error("请输入手机号码"));
                }
            }
        };
        return {
            uploadSuccess: false, //是否上传成功
            // fileList: [{ name: "food.jpg", url: "@/assets/image/home/end.jpg" }], //附件上传文件列表
            fileList: [], //附件上传文件列表
            fileFailList: [], //附件上传失败列表
            fileSuccessList: [], //附件上传成功列表
            qzjlFileFailList: [], //求职简历附件上传失败列表
            qzjlFileSuccessList: [], //求职简历附件上传成功列表
            cjbFileFailList: [], //成绩表附件上传失败列表
            cjbFileSuccessList: [], //成绩表附件上传成功列表
            jytjbFileFailList: [], //就业推荐表附件上传失败列表
            jytjbFileSuccessList: [], //就业推荐表附件上传成功列表

            showMessage: false, //是否显示上传照片图片信息
            selectJg: provinceAndCityData,
            showByxxSearchButton: true, //是否显示毕业学校查询按钮
            showSxzySearchButton: true, //是否显示所学专业查询按钮
            showQzjlFileMsg: false, //是否显示上传求职简历信息

            form: {
                xm: "", //姓名
                sfzhm: "", //身份证号
                xb: "", //性别
                mz: "", //民族
                csny: "", //出生年月
                zzmm: "", //政治面貌
                lxdh: "", //联系电话
                jg: [], //籍贯
                zw: "", //职务
                hjqkjtc: "", //获奖情况及特长
                yysp: "", //英语水平
                jsjsp: "", //计算机水平
                // jltdsj: "", //简历投递时间
                bysj: "", //毕业时间
                dyxl: "", //第一学历
                dyxlbyxx: "", //第一学历毕业学校
                dyxlsxzy: "", //第一学历所学专业
                dyxlsxzydm: "", //第一学历所学专业代码
                xxlb: "", //学校类别
                jyxs: "", // 教育形式
                sg: "", //身高
                tz: "", //体重
                // hxxl: "", //后续学历
                // hxxlbyxx: "", //后续学历毕业学校
                // hxxlsxzy: "", //后续学历所学专业
                zylb: "", //专业类别
                bmbk: "", //报名板块
                bz: "", //备注1（学习经历、社会实践等）
                // bz2: "", //备注2
                imageSrc: "", //图片
                gwlbmc: "",
                gwlbid: "",
                sfgwyx: "0", //是否国外院校，默认否
                rxsj: "", //入学时间
                sfyfbyjl: "0", //是否有服兵役经历
                fbykssj: "", //服兵役开始时间
                fbyjssj: "", //服兵役结束时间
                bkbyxx: "", //本科毕业学校
                bksxzy: "", //本科所学专业
                bksxzydm: "", //本科所学专业代码
            },
            rules: {
                xm: [
                    {
                        required: true,
                        message: "请输入姓名",
                        trigger: ["blur", "change"],
                    },
                ],
                sfzhm: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: ["blur", "change"],
                    },
                    identityRegPlus
                ],
                xb: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: ["blur", "change"],
                    },
                ],
                mz: [
                    {
                        required: true,
                        message: "请选择民族",
                        trigger: ["blur", "change"],
                    },
                ],
                bysj: [
                    {
                        required: true,
                        message: "请选择毕业时间",
                        trigger: ["blur", "change"],
                    },
                ],
                // jltdsj: [
                //   {
                //     required: true,
                //     message: "请选择简历投递时间",
                //     trigger: ["blur", "change"],
                //   },
                // ],
                csny: [
                    {
                        required: true,
                        message: "请选择出生年月",
                        trigger: ["blur", "change"],
                    },
                ],
                zzmm: [
                    {
                        required: true,
                        message: "请选择政治面貌",
                        trigger: ["blur", "change"],
                    },
                ],
                jg: [
                    {
                        required: true,
                        message: "请输入籍贯",
                        trigger: ["blur", "change"],
                    },
                ],
                // yysp: [
                //   {
                //     required: true,
                //     message: "请选择英语水平",
                //     trigger: ["blur", "change"]
                //   }
                // ],
                // jsjsp: [
                //   {
                //     required: true,
                //     message: "请选择计算机水平",
                //     trigger: ["blur", "change"]
                //   }
                // ],
                dyxl: [
                    {
                        required: true,
                        message: "请选择第一学历",
                        trigger: ["blur", "change"],
                    },
                ],
                dyxlbyxx: [
                    {
                        required: true,
                        message: "请输入第一学历毕业学校",
                        trigger: ["blur", "change"],
                    },
                ],
                dyxlsxzy: [
                    {
                        required: true,
                        message: "请输入第一学历所学专业",
                        trigger: ["blur", "change"],
                    },
                ],
                // zw: [
                //   {
                //     required: true,
                //     message: "请输入职务",
                //     trigger: ["blur", "change"]
                //   }
                // ],
                // hjqkjtc: [
                //   {
                //     required: true,
                //     message: "请输入获奖情况及特长",
                //     trigger: ["blur", "change"]
                //   }
                // ],
                lxdh: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: ["blur", "change"],
                    },
                    { validator: isMobileNumber, trigger: "blur" }
                ],
                gwlbmc: [
                    {
                        required: true,
                        message: "请选择拟应聘岗位",
                        trigger: ["blur", "change"],
                    },
                ],
                // bz: [
                //   {
                //     required: true,
                //     message: "请输入备注",
                //     trigger: ["blur", "change"]
                //   }
                // ]
                jyxs: [
                    {
                        required: true,
                        message: "请选择教育形式",
                        trigger: ["blur", "change"],
                    },
                ],
                sfgwyx: [
                    {
                        required: true,
                        message: "请选择是否国外院校",
                        trigger: ["blur", "change"],
                    },
                ],
                rxsj: [
                    {
                        required: true,
                        message: "请选择入学时间",
                        trigger: ["blur", "change"],
                    },
                ],
                sfyfbyjl: [
                    {
                        required: true,
                        message: "请选择是否有服兵役经历",
                        trigger: ["blur", "change"],
                    }
                ],
                fbykssj: [
                    {
                        required: false,
                        message: "请选择服兵役开始时间",
                        trigger: ["blur", "change"],
                    }
                ],
                fbyjssj: [
                    {
                        required: false,
                        message: "请选择服兵役结束时间",
                        trigger: ["blur", "change"],
                    }
                ],
                bkbyxx: [
                    {
                        required: true,
                        message: "请选择本科毕业学校",
                        trigger: ["blur", "change"],
                    }
                ],
                bksxzy: [
                    {
                        required: true,
                        message: "请选择本科所学专业",
                        trigger: ["blur", "change"],
                    }
                ]

            },
            options: {
                genderList: share.get("xb"),
                nationList: share.get("mz"),
                politicsFaceList: share.get("zzmm"),
                educationList: share.get("xl"),
                yyspList: share.get("yysp"),
                jsjspList: share.get("jsjsp"),
                collegeList: share.get("lb"),
                jyxsList: share.get("jyxs"),
                sfgwyxList: share.get("whether"),
                sfyfbyjlList: share.get("whether"),
            },
        };
    },
    watch: {
        data: {
            handler: function(newValue) {
                this.form.bmbk = newValue.bmbk;
                this.form.zylb = newValue.zylb;
            },
            immediate: true,
        },
        "form.sfzhm": function(newValue) {
            if (newValue.length == 18) {
                this.form.xb = parseInt(newValue.substr(16, 1)) % 2 == 1 ? "1" : "2"; //奇数男，偶数女
                this.form.csny = newValue.substr(6, 4) + "-" + newValue.substr(10, 2) + "-" + newValue.substr(12, 2);
            }
        },
        "form.imageSrc": function(newValue) {
            if (newValue == "") {
                this.showMessage = true;
            } else {
                this.showMessage = false;
            }
        },
        "qzjlFileSuccessList": function(newValue) {
            console.log('watch>>>', newValue);
            if (newValue.length > 0) {
                this.showQzjlFileMsg = false;
            }else {
                this.showQzjlFileMsg = true;
            }
        }
    },
    methods: {
        /**
         * 清除数据
         */
        clearField() {
            this.$refs.form.resetFields();
            this.form.imageSrc = "";
            this.showMessage = false;
            this.fileSuccessList = [];
            this.fileFailList = [];
            this.qzjlFileSuccessList = [];
            this.qzjlFileFailList = [];
            this.cjbFileSuccessList = [];
            this.cjbFileFailList = [];
            this.jytjbFileSuccessList = [];
            this.jytjbFileFailList = [];
        },
        searchUniversity(queryType){
            let xxmc = "";
            if ("dyxlbyxx" === queryType) {
                xxmc = this.form.dyxlbyxx;
            }
            if ("bkbyxx" === queryType) {
                xxmc = this.form.bkbyxx;
            }
            const data = {
                xxmc: xxmc,
                queryType: queryType
            }
            console.log('data>>>', data)
            this.$refs.searchUniversityDialog.open(data);
        },
        choiceUniversity(data){
            console.log('choiceUniversity>>>', data);
            if ('dyxlbyxx' === data.queryType) {
                this.form.dyxlbyxx = data.xxmc;
                this.form.xxlb = data.yxlb;
            }else {
                this.form.bkbyxx = data.xxmc;
            }
        },
        changeDyxl(){
            if (this.data.zplb == '2') {
                //高技能人才招聘
                //国外院校时，毕业学校、所学专业手动录入
                if (this.form.sfgwyx == '1') {
                    this.showByxxSearchButton = false;
                    this.showSxzySearchButton = false;
                    this.form.xxlb = "4";
                    if (this.form.dyxl == "99") {
                        this.form.dyxlsxzy = "无";
                    }else {
                        this.form.dyxlsxzy = "";
                    }
                    this.form.dyxlsxzydm = "";
                    this.form.dyxlbyxx = "";
                }else {
                    //非国外院校时
                    if (this.form.dyxl == "61") {
                        //学历是技工学校
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = false;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    } else if (this.form.dyxl == "40") {
                        //学历是中等专科
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = true;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    } else if (this.form.dyxl == "99") {
                        //学历是其他
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = false;
                        this.form.dyxlsxzy = "无";
                        this.form.dyxlsxzydm = "";
                    } else {
                        this.showByxxSearchButton = true;
                        this.showSxzySearchButton = true;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    }
                    this.form.xxlb = "";
                }
                this.form.bkbyxx = "";
                this.form.bksxzy = "";
                this.form.bksxzydm = "";
            }else {
                //高校毕业生招聘
                //学历改变时，专业信息重置，本科毕业学校、本科所学专业重置
                this.form.dyxlsxzy = "";
                this.form.dyxlsxzydm = "";
                this.form.bkbyxx = "";
                this.form.bksxzy = "";
                this.form.bksxzydm = "";
            }
        },
        changeSfgwyx() {
            if (this.data.zplb == "2") {
                //高技能人才招聘
                //国外院校时，毕业学校、所学专业手动录入
                if (this.form.sfgwyx == "1") {
                    this.showByxxSearchButton = false;
                    this.showSxzySearchButton = false;
                    this.form.xxlb = "4";
                    if (this.form.dyxl == "99") {
                        this.form.dyxlsxzy = "无";
                    }else {
                        this.form.dyxlsxzy = "";
                    }
                    this.form.dyxlsxzydm = "";
                    this.form.dyxlbyxx = "";
                }else {
                    //非国外院校时
                    if (this.form.dyxl == "61") {
                        //学历是技工学校
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = false;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    } else if (this.form.dyxl == "40") {
                        //学历是中等专科
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = true;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    } else if (this.form.dyxl == "99") {
                        //学历是其他
                        this.showByxxSearchButton = false;
                        this.showSxzySearchButton = false;
                        this.form.dyxlsxzy = "无";
                        this.form.dyxlsxzydm = "";
                    } else {
                        this.showByxxSearchButton = true;
                        this.showSxzySearchButton = true;
                        this.form.dyxlsxzy = "";
                        this.form.dyxlsxzydm = "";
                    }
                    this.form.xxlb = "";
                }
                this.form.dyxlbyxx = "";
            }else {
                //高校毕业生招聘
                if (this.form.sfgwyx == "1") {
                    this.showByxxSearchButton = false;
                    this.showSxzySearchButton = false;
                    this.form.xxlb = "4";
                }else {
                    this.showByxxSearchButton = true;
                    this.showSxzySearchButton = true;
                    this.form.xxlb = "";
                }

                //重置毕业学校、所学专业
                this.form.dyxlbyxx = "";
                this.form.dyxlzy = "";
                this.form.dyxlzydm = "";
            }
        },
        changeSfyfbyjl() {
            this.form.fbykssj = "";
            this.form.fbyjssj = "";
        },
        changeDyxlsxzy(){
            this.form.dyxlsxzydm = "";
        },
        searchMajor(){
            if(!this.form.dyxl){
                this.$message({
                    type: "warning",
                    message: "请选择学历",
                });

                return;
            }

            let zylb = "";
            if(this.form.dyxl == "11" || this.form.dyxl == "14"){
                zylb = "1";
            } else if(this.form.dyxl == "20"){
                zylb = "2";
            } else if(this.form.dyxl == "30"){
                zylb = "3";
            } else if(this.form.dyxl == "21"){
                zylb = "4"
            } else if(this.form.dyxl == "40" || this.form.dyxl == "61"){
                zylb = "5"
            }
            this.$refs.searchMajorDialog.open({
                keyword:this.form.dyxlsxzy,
                zylb: zylb,
                queryType: "dyxlsxzy"
            });
        },
        searchBkMajor() {
            this.$refs.searchMajorDialog.open({
                keyword: this.form.bksxzy,
                zylb: '2',
                queryType: "bksxzy"
            });
        },
        choiceMajor(data){
            const queryType = data.queryType;
            if ("dyxlsxzy" === queryType) {
                this.form.dyxlsxzy = data.zymc;
                this.form.dyxlsxzydm = data.zydm;
            }else {
                this.form.bksxzy = data.zymc;
                this.form.bksxzydm = data.zydm;
            }
        },
        searchGw(){
            this.$refs.searchGwDialog.open({
                keyword: this.form.gwlbmc,
                zphdid: this.data.zphdid,
            });
        },
        choiceGw(data){
            this.form.gwlbid = data.zpzyid;
            this.form.gwlbmc = data.zylb + "-" + data.ssbk;
        },
        /**
         * 附件删除
         */
        deleteFile(index, type) {
            let fjxxid = "";
            if(type == "1"){
                fjxxid = this.qzjlFileSuccessList[index].fjxxid;
            } else if(type == "2") {
                fjxxid = this.cjbFileSuccessList[index].fjxxid;
            } else if(type == "3") {
                fjxxid = this.jytjbFileSuccessList[index].fjxxid;
            } 
            let param = {
                fjxxid: fjxxid,
            };
            request
                .delFile(param)
                .then((res) => {
                    console.log(res);
                    this.$message({
                        message: "删除成功! ",
                        type: "success",
                    });
                    if(type == "1"){
                        this.qzjlFileSuccessList.splice(index, 1);
                    } else if(type == "2") {
                        this.cjbFileSuccessList.splice(index, 1);
                    } else if(type == "3") {
                        this.jytjbFileSuccessList.splice(index, 1);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        /**
         * 附件移除（上传失败列表）
         */
        removeFile(index, type) {
            if(type == "1"){
                this.qzjlFileFailList.splice(index, 1);
            } else if(type == "2"){
                this.cjbFileFailList.splice(index, 1);
            } else if(type == "3"){
                this.jytjbFileFailList.splice(index, 1);
            }
        },
        /**
         * 上传失败的文件重新上传
         */
        reUploadFile(index, type) {
            let fileData = new FormData();
            let item;
            if(type == "1"){
                if(this.qzjlFileSuccessList.length > 0){
                    this.$message({
                        message: "请删除求职简历成功列表中已有的文件再上传此文件",
                        type: "warning",
                    });
                    return;
                }
                item = this.qzjlFileFailList[index];
            } else if(type == "2"){
                if(this.cjbFileSuccessList.length > 0){
                    this.$message({
                        message: "请删除成绩表成功列表中已有的文件再上传此文件",
                        type: "warning",
                    });
                    return;
                }
                item = this.cjbFileFailList[index];
            } else if(type == "3"){
                if(this.jytjbFileSuccessList.length > 0){
                    this.$message({
                        message: "请删除就业推荐表成功列表中已有的文件再上传此文件",
                        type: "warning",
                    });
                    return;
                }
                item = this.jytjbFileFailList[index];
            }

            //过滤选出文件名已存在于成功列表的数据
            let repeat = this.fileSuccessList.filter((ele) => {
                return ele.name == item.name;
            });
            if (repeat.length > 0) {
                this.$message({
                    message: "请勿上传重复文件",
                    type: "warning",
                });
                return;
            }

            fileData.append("uploadfile", item.raw);
            fileData.append("filename", encodeURI(item.raw.name));
            fileData.append("fjlylx", "3");
            request
                .setBMISection(fileData)
                .then((res) => {
                    console.log(res);
                    item.fjxxid = res.fjxxid;

                    if(type == "1"){
                        this.qzjlFileSuccessList.push(item);
                        this.qzjlFileFailList.splice(index, 1);
                    } else if(type == "2"){
                        this.cjbFileSuccessList.push(item);
                        this.cjbFileFailList.splice(index, 1);
                    } else if(type == "3"){
                        this.jytjbFileSuccessList.push(item);
                        this.jytjbFileFailList.splice(index, 1);
                    }

                    this.$message({
                        message: "文件  " + item.raw.name + "  重新上传上传成功! ",
                        type: "error",
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        /**
         * 附件上传
         */
        uploadFile(type) {
            while (this.fileList.length > 0) {
                let fileData = new FormData();
                let item = this.fileList.shift();
                //过滤选出文件名已存在于成功列表的数据
                let repeat = this.fileSuccessList.filter((ele) => {
                    return ele.name == item.name;
                });
                if (repeat.length > 0) {
                    this.$message({
                        message: "请勿上传重复文件",
                        type: "warning",
                    });
                    continue;
                }
                fileData.append("uploadfile", item.raw);
                fileData.append("filename", encodeURI(item.raw.name));
                // fileData.append("fjly", "28821041610000000043");
                fileData.append("fjlylx", "3");
                request
                    .uploadFile(fileData)
                    .then((res) => {
                        console.log(res);
                        item.fjxxid = res.fjxxid;

                        if(type == "1"){
                            this.qzjlFileSuccessList.push(item);
                        } else if(type == "2"){
                            this.cjbFileSuccessList.push(item);
                        } else if(type == "3"){
                            this.jytjbFileSuccessList.push(item);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        // this.$message({
                        //   // message: err,
                        //   message: "文件  " + item.raw.name + "  上传失败! " + err,
                        //   type: "error"
                        // });
                        if(type == "1"){
                            this.qzjlFileFailList.push(item);
                        } else if(type == "2"){
                            this.cjbFileFailList.push(item);
                        } else if(type == "3"){
                            this.jytjbFileFailList.push(item);
                        }
                    });
            }
        },
        /**
         * 附件上传
         */
         setBMISection(type) {
            while (this.fileList.length > 0) {
                let fileData = new FormData();
                let item = this.fileList.shift();
                //过滤选出文件名已存在于成功列表的数据
                let repeat = this.fileSuccessList.filter((ele) => {
                    return ele.name == item.name;
                });
                if (repeat.length > 0) {
                    this.$message({
                        message: "请勿上传重复文件",
                        type: "warning",
                    });
                    continue;
                }
                fileData.append("uploadfile", item.raw);
                fileData.append("filename", encodeURI(item.raw.name));
                fileData.append("fjlylx", "3");
                if (type == "1") {
                    fileData.append("bmdbh", "qzjl_zpjh");
                    fileData.append("bmdmc", encodeURI("求职简历"));
                }
                if (type == "2") {
                    fileData.append("bmdbh", "cjb_zpjh");
                    fileData.append("bmdmc", encodeURI("成绩表"));
                }
                if (type == "3") {
                    fileData.append("bmdbh", "jytjb_zpjh");
                    fileData.append("bmdmc", encodeURI("就业推荐表"));
                }
                if (type == "4") {
                    fileData.append("bmdbh", "zp_zpjh");
                    fileData.append("bmdmc", encodeURI("个人照片"));
                }
                
                request
                    .setBMISection(fileData)
                    .then((res) => {
                        console.log(res);
                        item.fjxxid = res.fjxxid;

                        if(type == "1"){
                            this.qzjlFileSuccessList.push(item);
                        } else if(type == "2"){
                            this.cjbFileSuccessList.push(item);
                        } else if(type == "3"){
                            this.jytjbFileSuccessList.push(item);
                        } else if(type == "4"){
                            this.zpFileSuccessList.push(item);
                            this.getBase64(item.raw).then((src) => {
                                this.form.imageSrc = src;
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        // this.$message({
                        //   // message: err,
                        //   message: "文件  " + item.raw.name + "  上传失败! " + err,
                        //   type: "error"
                        // });
                        if(type == "1"){
                            this.qzjlFileFailList.push(item);
                        } else if(type == "2"){
                            this.cjbFileFailList.push(item);
                        } else if(type == "3"){
                            this.jytjbFileFailList.push(item);
                        }
                    });
            }
        },
        /**
         * 附件上传文件添加回调方法
         */
        qzjlUploadChange(file, fileList) {
            if(this.qzjlFileSuccessList.length > 0){
                fileList.shift();
                this.$message.error("请删除已上传文件后再上传新文件！");
                return;
            }

            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传附件大小不能超过 10MB!");
                return;
            }
            console.log('>>>:qzjlUploadChange');
            this.fileList = fileList;
            // this.uploadFile("1");
            this.setBMISection("1");
        },
        cjbUploadChange(file, fileList) {
            if(this.cjbFileSuccessList.length > 0){
                fileList.shift();
                this.$message.error("请删除已上传文件后再上传新文件！");
                return;
            }

            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传附件大小不能超过 10MB!");
                return;
            }
            console.log('>>>:cjbUploadChange');
            this.fileList = fileList;
            // this.uploadFile("2");
            this.setBMISection("2");
        },
        jytjbUploadChange(file, fileList) {
            if(this.jytjbFileSuccessList.length > 0){
                fileList.shift();
                this.$message.error("请删除已上传文件后再上传新文件！");
                return;
            }

            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传附件大小不能超过 10MB!");
                return;
            }
            console.log('>>>:jytjbUploadChange');
            this.fileList = fileList;
            // this.uploadFile("3");
            this.setBMISection("3");
        },

        /**
         * 父组件获取校验后的数据
         */
        getData() {
            console.log('-------');
            let data_fjxx = [];
            for (let i = 0; i < this.fileSuccessList.length; i++) {
                let item = {
                    fjxxid: this.fileSuccessList[i].fjxxid,
                };
                data_fjxx.push(item);
            }

            let qzjl_fjxxid = "", cjb_fjxxid = "", jytjb_fjxxid = "";
            if(this.qzjlFileSuccessList.length > 0){
                qzjl_fjxxid = this.qzjlFileSuccessList[0].fjxxid;
            }
            if(this.cjbFileSuccessList.length > 0){
                cjb_fjxxid = this.cjbFileSuccessList[0].fjxxid;
            }
            if(this.jytjbFileSuccessList.length > 0){
                jytjb_fjxxid = this.jytjbFileSuccessList[0].fjxxid;
            }

            let data = {
                xm: this.form.xm, //姓名
                xb: this.form.xb, //性别
                mz: this.form.mz, //民族
                csrq: this.form.csny, //出生日期
                zzmm: this.form.zzmm, //政治面貌
                yxzjhm: this.form.sfzhm, //有效证件号码
                lxdh: this.form.lxdh, //联系电话
                jg: this.form.jg, //家庭住址
                zp: this.form.imageSrc.split(",")[1], //照片

                dyxl: this.form.dyxl, //第一学历
                dyxlbyxx: this.form.dyxlbyxx, //第一学历毕业学校
                dyxlzy: this.form.dyxlsxzy, //第一学历专业
                dyxlzydm: this.form.dyxlsxzydm, //第一学历专业
                xxlb: this.form.xxlb, //学校类别
                jyxs: this.form.jyxs, // 教育形式
                sg: this.form.sg, //身高
                tz: this.form.tz, //体重
                // hxxl: this.form.hxxl, //后续学历
                // hxxlbyxx: this.form.hxxlbyxx, //后续学历毕业院校
                // hxxlzy: this.form.hxxlsxzy, //后续学历专业

                yysp: this.form.yysp, //英语水平
                jsjsp: this.form.jsjsp, //计算机水平
                bysj: this.form.bysj, //毕业时间
                zw: this.form.zw, //职务
                hjqkjtc: this.form.hjqkjtc, //获奖情况及特长
                zpzyid: this.form.gwlbid, //拟应聘岗位
                bz: this.form.bz, //备注
                zyyjfx: this.form.zyyjfx, //专业研究方向

                data_fjxx: JSON.stringify(data_fjxx),
                qzjl_fjxxid: qzjl_fjxxid,
                cjb_fjxxid: cjb_fjxxid,
                jytjb_fjxxid: jytjb_fjxxid,

                rxsj: this.form.rxsj, //入学时间
                sfyfbyjl: this.form.sfyfbyjl, //是否有服兵役经历
                fbykssj: this.form.fbykssj, //服兵役开始时间
                fbyjssj: this.form.fbyjssj, //服兵役结束时间
                sfgwyx: this.form.sfgwyx, //是否国外院校
                bkbyxx: this.form.bkbyxx, //本科毕业学校
                bksxzy: this.form.bksxzy, //本科所学专业
            };
            
            return data;
        },
        /**
         * 校验数据是否都已填写
         */
        validate() {
            let validated = false;
            this.$refs.form.validate((valid) => {
                if (valid) {
                    validated = true;
                } else {
                    validated = false;
                }
            });
            //检查是否选择专业
            if(this.showSxzySearchButton && this.form.dyxlsxzydm == ""){
                this.$message({
                    message: "请点击放大镜选择所学专业",
                    type: "warning",
                });
                validated = false;
            }
            //检查是否选择岗位
            if(this.form.gwlbid == ""){
                this.$message({
                    message: "请点击放大镜选择拟应聘岗位",
                    type: "warning",
                });
                validated = false;
            }
            //检查是否已选择照片
            if (this.form.imageSrc == "") {
                this.showMessage = true;
                validated = false;
            } else {
                this.showMessage = false;
            }
            //检查是否已上传求职简历
            if (this.qzjlFileSuccessList.length <= 0) {
                this.showQzjlFileMsg = true;
                validated = false;
            }else {
                this.showQzjlFileMsg = false;
            }
            return validated;
        },
        imageChange(file) {
            const isLt = file.size / 1024 / 1024 < 0.1;
            if (!isLt) {
                this.$message.error("个人照片大小不能超过100kb!");
            }
            if (isLt) {
                let that = this;
                this.getBase64(file.raw).then((src) => {
                    that.form.imageSrc = src;
                });
            }
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                let imageSrc;
                reader.readAsDataURL(file);
                reader.onload = function() {
                    imageSrc = reader.result;
                };
                reader.onloadend = function() {
                    resolve(imageSrc);
                };
                reader.onerror = function(err) {
                    reject(err);
                };
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.file-upload {
    display: flex;
    justify-content: space-between;
    .success {
        color: #12c3af;
    }
    .fail {
        color: #f56c6c;
    }
}
.baseinfo-image {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
    .image {
        margin: 10px;
        padding: 7px;
        width: 150px;
        height: 180px;
    }
}
.red {
    color: #f56c6c;
}
.show {
    display: block;
}
.hide {
    display: none;
}
.header {
    font-weight: bold;
    padding: 10px;
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.modify {
    color: #2a8ae0;
    &:hover {
        cursor: pointer;
    }
}
.delete {
    color: #ff5858;
    &:hover {
        cursor: pointer;
    }
}
</style>
